import React from 'react';

function BrandLogo({ className = 'h-10 w-10' }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ''}/logo.png`}
      alt=""
      className={`${className} object-contain shrink-0`}
      aria-hidden="true"
    />
  );
}

export default BrandLogo;
